import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Neha Sharma",
    course: "Full Stack Development",
    feedback: "The course was well structured and the live sessions were really helpful. The support team is quick to respond.",
    image: "https://randomuser.me/api/portraits/women/79.jpg",
    rating: 5,
  },
  {
    name: "Arjun Reddy",
    course: "Data Science",
    feedback: "Really happy with the content and projects. I gained confidence to crack interviews.",
    image: "https://randomuser.me/api/portraits/men/42.jpg",
    rating: 4,
  },
  {
    name: "Sneha Rao",
    course: "Cloud Computing",
    feedback: "Live projects made learning fun and practical. Great experience overall!",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    rating: 5,
  },
  {
    name: "Rohit Verma",
    course: "Machine Learning",
    feedback: "The instructor made complex topics easy to understand. Highly recommend.",
    image: "https://randomuser.me/api/portraits/men/38.jpg",
    rating: 5,
  },
  {
    name: "Aisha Khan",
    course: "UI/UX Design",
    feedback: "This course helped me land my first internship as a designer. The mentor was amazing.",
    image: "https://randomuser.me/api/portraits/women/50.jpg",
    rating: 4,
  },
  {
    name: "Vikram Das",
    course: "DevOps",
    feedback: "I liked the real-world deployment practice. The sessions were clear and informative.",
    image: "https://randomuser.me/api/portraits/men/12.jpg",
    rating: 5,
  },
  {
    name: "Meera Iyer",
    course: "Java Backend",
    feedback: "Assignments helped me a lot in understanding the backend development.",
    image: "https://randomuser.me/api/portraits/women/39.jpg",
    rating: 4,
  },
  {
    name: "Rishi Singh",
    course: "React & Frontend",
    feedback: "The UI part was fun to learn and implement. Projects were industry-standard.",
    image: "https://randomuser.me/api/portraits/men/61.jpg",
    rating: 5,
  },
  {
    name: "Aparna N",
    course: "Python Programming",
    feedback: "The classes were interactive and the mentor was very supportive.",
    image: "https://randomuser.me/api/portraits/women/24.jpg",
    rating: 5,
  },
  {
    name: "Aditya Rao",
    course: "Cybersecurity",
    feedback: "It gave me a clear insight into ethical hacking and defense strategies.",
    image: "https://randomuser.me/api/portraits/men/49.jpg",
    rating: 4,
  },
  {
    name: "Priya Sharma",
    course: "AI & Deep Learning",
    feedback: "AI has always fascinated me. This course made it even more exciting!",
    image: "https://randomuser.me/api/portraits/women/45.jpg",
    rating: 5,
  },
  {
    name: "Manoj Kumar",
    course: "Business Analytics",
    feedback: "Loved the analytical case studies. Helped me in real work scenarios.",
    image: "https://randomuser.me/api/portraits/men/36.jpg",
    rating: 4,
  },
];

const TestimonialsSection = () => {
  const [index, setIndex] = useState(0);
  const visibleCount = 3;

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + visibleCount) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const visibleTestimonials = testimonials.slice(index, index + visibleCount).concat(
    testimonials.slice(0, Math.max(0, index + visibleCount - testimonials.length))
  );

  return (
    <section className="py-20 px-4 sm:px-10 md:px-20 transition-all duration-700 ease-in-out">
      <h2 className="text-4xl font-bold text-center text-blue-900 mb-12">
        What Our Students Say
      </h2>
      <div className="grid gap-6 md:grid-cols-3 transition-all duration-700 ease-in-out">
        {visibleTestimonials.map((testimonial, idx) => (
          <div
            key={idx}
            className="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center text-center transform transition-all duration-700 hover:shadow-2xl"
          >
            <img
              src={testimonial.image}
              alt={testimonial.name}
              className="w-20 h-20 rounded-full object-cover border-4 border-blue-500 mb-4"
            />
            <h3 className="font-semibold text-lg text-gray-900">{testimonial.name}</h3>
            <span className="text-sm text-blue-600 mb-2">{testimonial.course}</span>
            <div className="flex mb-4">
              {[...Array(5)].map((_, starIdx) => (
                <FaStar
                  key={starIdx}
                  className={`text-xl ${
                    starIdx < testimonial.rating ? "text-yellow-400" : "text-gray-300"
                  }`}
                />
              ))}
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              “{testimonial.feedback}”
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
